const setAudienceIdAction = ({ commit }, audienceId) => {
  commit('setAudienceId', audienceId)
}

export default {
  setAudienceIdAction,
}
